var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar__links"},[_c('ul',{staticClass:"navbar__links-list"},_vm._l((_vm.filteredModuleLinks),function(link){return _c('li',{key:link.id,on:{"click":function($event){return _vm.setDefaultPath(link)}}},[_c('router-group',{attrs:{"routes-group":link}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }